export default function About() {
  return (
    <div>
      {/* Page Header */}
      <section className="relative h-[300px] md:h-[380px] flex items-center justify-center overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Professional%20corporate%20office%20with%20navy%20blue%20and%20warm%20orange%20accent%20decor%2C%20modern%20minimalist%20interior%20with%20glass%20partitions%20and%20world%20map%20wall%20art%2C%20clean%20elegant%20design%2C%20natural%20light%20streaming%20through%20large%20windows%2C%20premium%20feel%2C%20no%20people%20visible&width=1920&height=600&seq=about-premium-visa-header&orientation=landscape"
          alt="About Premium Visa Solutions"
          className="absolute inset-0 w-full h-full object-cover object-top"
          title="About Premium Visa Solutions - Professional Visa Support"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/75 to-primary-950/65"></div>
        <div className="relative z-10 text-center px-4">
          <h1 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-3">About Us</h1>
          <p className="text-sm md:text-base text-background-50/80 max-w-[600px] mx-auto">
            Your trusted partner for professional visa support from Zambia
          </p>
        </div>
      </section>

      {/* Who We Are */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8 lg:px-12">
          <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
            <div className="flex-1">
              <span className="inline-block bg-primary-100 text-primary-700 text-xs font-semibold px-3 py-1 rounded-full mb-3">Who We Are</span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">
                Professional Visa Support Based in Lusaka, Zambia
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                Premium Visa Solutions is a Zambia-based visa support and processing assistance company. We help individuals, families, companies, and organisations prepare and manage visa applications with confidence. We are not an embassy or government authority — our role is to assist clients with documentation, appointment preparation, application support, document collection, tracking, and communication during the visa process.
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                Founded with the mission to simplify the visa application process for Zambians and residents, we bridge the gap between applicants and embassies. Our team of experienced visa consultants understands the specific requirements of each destination country and guides you through every step.
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                Located at Plot No. 1194, Corner of Lunzua Road / Addis Ababa Road in Lusaka, our office is easily accessible for clients who prefer in-person consultations. For those who prefer remote assistance, our Apply From Home service brings our expertise directly to you.
              </p>
            </div>
            <div className="flex-1">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20professional%20office%20setting%20with%20navy%20blue%20branding%2C%20computer%20screens%20displaying%20travel%20documents%20and%20world%20maps%2C%20clean%20elegant%20workspace%20with%20passports%20and%20visa%20stamps%20on%20desk%2C%20warm%20orange%20accent%20lighting%2C%20corporate%20professional%20atmosphere%2C%20no%20people&width=800&height=600&seq=about-premium-visa-team&orientation=landscape"
                alt="Premium Visa Solutions professional office"
                className="w-full rounded-lg object-cover object-top"
                title="Premium Visa Solutions - Lusaka Office"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Values */}
      <section className="py-14 md:py-20 bg-secondary-100">
        <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
            <div className="bg-background-50 border border-secondary-200 rounded-lg p-6 md:p-8">
              <div className="w-12 h-12 flex items-center justify-center bg-accent-100 rounded-lg mb-4">
                <i className="ri-focus-3-line text-accent-600 text-xl"></i>
              </div>
              <h3 className="font-heading font-semibold text-xl md:text-2xl text-foreground-900 mb-3">Our Mission</h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                Our mission is to make visa applications accessible, transparent, and stress-free for everyone in Zambia. We are committed to providing professional, reliable, and efficient visa support services that empower our clients to travel with confidence. Every application we handle receives the same level of dedication and attention to detail.
              </p>
            </div>
            <div className="bg-background-50 border border-secondary-200 rounded-lg p-6 md:p-8">
              <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-lg mb-4">
                <i className="ri-eye-line text-primary-600 text-xl"></i>
              </div>
              <h3 className="font-heading font-semibold text-xl md:text-2xl text-foreground-900 mb-3">Our Vision</h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                To become Zambia&apos;s most trusted and preferred visa support company, recognised for excellence in service delivery, transparency, and client satisfaction. We envision a future where every Zambian can access professional visa assistance without stress, confusion, or unnecessary delays.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-14 md:py-20 bg-background-50">
        <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8 lg:px-12">
          <div className="text-center mb-12">
            <span className="inline-block bg-accent-100 text-accent-700 text-xs font-semibold px-3 py-1 rounded-full mb-3">Why Choose Us</span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
              What Sets Premium Visa Solutions Apart
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-[650px] mx-auto">
              We combine experience, professionalism, and personal attention to deliver outstanding visa support services.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            <div className="bg-secondary-100/70 border border-secondary-200 rounded-lg p-5 md:p-6">
              <div className="w-10 h-10 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg mb-3">
                <i className="ri-verified-badge-line text-lg"></i>
              </div>
              <h4 className="font-heading font-semibold text-base text-foreground-900 mb-2">Professional Expertise</h4>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Our team has extensive knowledge of visa requirements for over 30 countries, ensuring your application meets all embassy standards.
              </p>
            </div>
            <div className="bg-secondary-100/70 border border-secondary-200 rounded-lg p-5 md:p-6">
              <div className="w-10 h-10 flex items-center justify-center bg-accent-500 text-background-50 rounded-lg mb-3">
                <i className="ri-home-office-line text-lg"></i>
              </div>
              <h4 className="font-heading font-semibold text-base text-foreground-900 mb-2">Apply From Home</h4>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Complete your entire visa application from the comfort of your home or office. Our team comes to you for document collection.
              </p>
            </div>
            <div className="bg-secondary-100/70 border border-secondary-200 rounded-lg p-5 md:p-6">
              <div className="w-10 h-10 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg mb-3">
                <i className="ri-secure-payment-line text-lg"></i>
              </div>
              <h4 className="font-heading font-semibold text-base text-foreground-900 mb-2">Secure Document Handling</h4>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Your passports and sensitive documents are handled with the highest level of security and confidentiality at all times.
              </p>
            </div>
            <div className="bg-secondary-100/70 border border-secondary-200 rounded-lg p-5 md:p-6">
              <div className="w-10 h-10 flex items-center justify-center bg-accent-500 text-background-50 rounded-lg mb-3">
                <i className="ri-timer-line text-lg"></i>
              </div>
              <h4 className="font-heading font-semibold text-base text-foreground-900 mb-2">Real-Time Tracking</h4>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Track your application status at every stage using your unique PVS reference number. No more wondering where your application stands.
              </p>
            </div>
            <div className="bg-secondary-100/70 border border-secondary-200 rounded-lg p-5 md:p-6">
              <div className="w-10 h-10 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg mb-3">
                <i className="ri-customer-service-2-line text-lg"></i>
              </div>
              <h4 className="font-heading font-semibold text-base text-foreground-900 mb-2">Dedicated Support</h4>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Each client is assigned a dedicated visa consultant who provides personalised guidance from application to decision.
              </p>
            </div>
            <div className="bg-secondary-100/70 border border-secondary-200 rounded-lg p-5 md:p-6">
              <div className="w-10 h-10 flex items-center justify-center bg-accent-500 text-background-50 rounded-lg mb-3">
                <i className="ri-building-4-line text-lg"></i>
              </div>
              <h4 className="font-heading font-semibold text-base text-foreground-900 mb-2">Corporate & Group Support</h4>
              <p className="text-sm text-foreground-600 leading-relaxed">
                We provide specialised visa support for companies, NGOs, and organisations handling group travel and business delegations.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Disclaimer */}
      <section className="py-10 md:py-14 bg-accent-100/70">
        <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8 lg:px-12">
          <div className="flex items-start gap-4">
            <div className="w-8 h-8 flex items-center justify-center bg-accent-500 text-background-50 rounded-full flex-shrink-0 mt-0.5">
              <i className="ri-information-line text-sm"></i>
            </div>
            <div>
              <h4 className="font-heading font-semibold text-base text-foreground-900 mb-2">Important Notice</h4>
              <p className="text-sm text-foreground-700 leading-relaxed">
                Premium Visa Solutions is an independent visa support and application assistance company based in Zambia. We are not an embassy, consulate, immigration authority, or government office. Final visa decisions are made only by the relevant embassy, consulate, immigration department, or official visa authority.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}